import uniq from "lodash/uniq";
import omit from "lodash/omit";
import without from "lodash/without";
import isEqual from "lodash/isEqual";
import { create as createOutcomeHelper } from "@/store/modules/outcomeHelpers";

const reactions = {
	initialized: ( state, {
		meeting,
		meetingPermissions,
		assignedTeam,
		organizer,
		invitees,
		meetingOutcomeMap,
		topicOutcomeIdMap,
		topicFieldMap,
		outcomeFieldMap,
		newOutcomeFieldMap,
		meetingInviteeMap,
		timezone,
		userProfile,
	} ) => {
		state.agendaMeetingId = meeting.id;
		state.meeting = meeting;
		state.meetingPermissions = meetingPermissions;
		state.organizer = organizer;
		state.invitees = invitees;
		state.assignedTeam = assignedTeam;
		state.meetingOutcomeMap = meetingOutcomeMap;
		state.topicOutcomeIdMap = topicOutcomeIdMap;
		state.topicFieldMap = topicFieldMap;
		state.outcomeFieldMap = outcomeFieldMap;
		state.newOutcomeFieldMap = newOutcomeFieldMap;
		state.meetingInviteeMap = meetingInviteeMap;
		state.timezone = timezone;
		state.userProfile = userProfile;
	},
	updated: ( state, updatedState ) => {
		/*
		meetingPermissions,
		assignedTeam,
		organizer,
		meetingOutcomeMap,
		topicOutcomeIdMap,
		outcomeFieldMap,
		newOutcomeFieldMap,
		 */
		// TODO: more granular updates
		Object.keys( updatedState ).forEach( fieldName => {
			if ( !isEqual( state[ fieldName ], updatedState[ fieldName ] ) ) {
				state[ fieldName ] = updatedState[ fieldName ];
			}
		} );
	},
	existingOutcomeFieldUpdated: ( state, { outcomeField, } ) => {
		state.outcomeFieldMap = {
			...state.outcomeFieldMap,
			[ outcomeField.id ]: outcomeField,
		};
	},
	newOutcomeFieldUpdated: ( state, { topicId, newOutcomeField, } ) => {
		state.newOutcomeFieldMap = {
			...state.newOutcomeFieldMap,
			[ topicId ]: newOutcomeField,
		};
	},
	outcomeSaved: ( state, { outcome, } ) => {
		const { meeting, userProfile, timezone, } = state;

		const outcomeHelper = createOutcomeHelper( { meeting, userProfile, timezone, } );

		const outcomeField = outcomeHelper.createField( outcome );

		state.outcomeFieldMap = {
			...state.outcomeFieldMap,
			[ outcome.id ]: outcomeField,
		};

		const { id, topicId, } = outcomeField.currentOutcome;
		state.meetingOutcomeMap[ id ] = { ...outcomeField.currentOutcome, };

		const topicOutcomeIds = state.topicOutcomeIdMap[ topicId ] || [];
		state.topicOutcomeIdMap = {
			...state.topicOutcomeIdMap,
			[ topicId ]: uniq( [ ...topicOutcomeIds, id, ] ),
		};
	},
	outcomeDeleted: ( state, { topicId, outcomeId, } ) => {
		state.meetingOutcomeMap = omit( state.meetingOutcomeMap, outcomeId );

		const prunedTopicOutcomeIds = without( state.topicOutcomeIdMap[ topicId ], outcomeId );
		state.topicOutcomeIdMap = {
			...state.topicOutcomeIdMap,
			[ topicId ]: prunedTopicOutcomeIds,
		};

		state.outcomeFieldMap = omit( state.outcomeFieldMap, outcomeId );
	},
};

export default reactions;



// WEBPACK FOOTER //
// ./src/store/modules/meetingAgenda/reactions.js